import React from 'react';

import { MYBAYPHOTO_OAUTH_CLIENT_ID, MYBAYPHOTO_OAUTH_CLIENT_SECRET } from 'utils/globals';

const csrfField = document.querySelector('meta[name="csrf-token"]');
const csrfToken = csrfField?.getAttribute('content') || '';

type SignInProps = {
  text: string;
  className?: string;
};

function SignInSSO({ text, className = '' }: SignInProps) {
  const signInHref = `/users/auth/mybayphoto?redirect_url=${encodeURIComponent(
    window.location.href
  )}`;

  return (
    <form method="post" action={signInHref}>
      <input type="hidden" name="authenticity_token" value={csrfToken || ''} />
      <input type="hidden" name="client_id" value={MYBAYPHOTO_OAUTH_CLIENT_ID} />
      <input type="hidden" name="client_secret" value={MYBAYPHOTO_OAUTH_CLIENT_SECRET} />
      <input className={className} type="submit" value={text} />
    </form>
  );
}

export default SignInSSO;
